import RoutesMap from "route_control/RouteControl"
import { Dashboard, SuperadminDashboard, AdminDashboard, XpressAdminDashboard } from "pages/dashboard"

const DashboardRoute = () => {
    return [
        {
            path: RoutesMap.SUPERADMIN_DASHBOARD.path,
            element: <SuperadminDashboard />
        },
        {
            path: RoutesMap.DASHBOARD.path,
            element: <Dashboard />
        },
        {
            path: RoutesMap.DASHBOARDSECOND.path,
            element: <Dashboard />
        },
        {
            path: RoutesMap.ADMIN_DASHBOARD.path,
            element: <AdminDashboard />
        },
        {
            path: RoutesMap.XPRESS_ADMIN_DASHBOARD.path,
            element: <XpressAdminDashboard />
        }
    ]
}

export default DashboardRoute;